import type { ProfileSummary } from "../helper/interface";

interface ProfileAffiliationSummaryProps {
  profile: ProfileSummary | null;
}

const ProfileAffiliationSummary = ({ profile }: ProfileAffiliationSummaryProps) => {
  const familyName = profile?.familyName?.trim();
  const partnerMemberships = profile?.partnerMemberships ?? [];

  if (!familyName && partnerMemberships.length === 0) {
    return null;
  }

  return (
    <div className="profile-affiliations" aria-label="Account memberships">
      {familyName && (
        <div className="profile-affiliation-row">
          <span className="profile-affiliation-type">Family:</span>
          <strong title={familyName}>{familyName}</strong>
        </div>
      )}
      {partnerMemberships.map((partner) => (
        <div className="profile-affiliation-row" key={partner.idPartner}>
          <span className="profile-affiliation-type">Partner:</span>
          <strong title={partner.partnerName}>{partner.partnerName}</strong>
        </div>
      ))}
    </div>
  );
};

export default ProfileAffiliationSummary;
